/** The two shipped breakpoints, shared by the shell (matchMedia) and its Tailwind variants (`max-[760px]`, `max-[1100px]`). */
export const RAIL_VIEWPORT = '(max-width: 1100px)';
export const BOTTOM_BAR_VIEWPORT = '(max-width: 760px)';
